document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link || link.hash !== '#open-chat') return;
    if (!link) return;
    try {
        window.remark('open');
    } catch (e) {
        console.warn('remark chat is not available', e);
    }
});
